'use strict';

import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

// import { areas, disclaimer } from '@/assets/data/fr';
import { ViewType } from '../constants';


const state = {
	areas: [],
	disclaimer: null,
	loading: false,

	isAppReady: false,

	// view
	view: ViewType.Grid,
	navPaneVisible: true,

	// toolbars
	toolbarIconColor: 'secondary',
	toolbarIconSize: 22,

	// debug
	debugMode: !!(process.env.VUE_APP_DEBUG === 'true' || window.DEBUG),
	debugMailTo: process.env.VUE_APP_DEBUG_EMAIL_TO,
	debugMailSubject: process.env.VUE_APP_DEBUG_EMAIL_SUBJECT,
};

export { state, getters, mutations, actions };